import React, { useEffect, useState } from 'react';
import { Header } from './Header';
import { Nav } from './Nav';
import { Footer } from './Footer';
import { LayoutContainer, MainContent } from './Layout.styles';

export interface LayoutProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  children: React.ReactNode;
  onLogout: () => void;
  userName?: string;
  userRole?: string;
  onOpenMessagingDrawer?: () => void;
  onNavigateLegal?: (page: 'privacy' | 'terms' | 'help') => void;
}

export const Layout: React.FC<LayoutProps> = ({
  activeTab,
  setActiveTab,
  children,
  onLogout,
  userName,
  userRole,
  onOpenMessagingDrawer,
  onNavigateLegal,
}) => {
  const [navOpen, setNavOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const isMessagingTab = activeTab === 'messaging';

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  }, [activeTab]);

  const handleMenuToggle = () => {
    setNavOpen(!navOpen);
  };

  const handleNavClose = () => {
    setNavOpen(false);
  };

  return (
    <LayoutContainer>
      <Header
        onMenuToggle={handleMenuToggle}
        onLogout={onLogout}
        onNavigate={setActiveTab}
        userName={userName}
        userRole={userRole}
        onOpenMessagingDrawer={onOpenMessagingDrawer}
      />
      <Nav
        isOpen={navOpen}
        onClose={handleNavClose}
        activeTab={activeTab}
        onNavigate={setActiveTab}
        isCollapsed={isCollapsed}
        onToggleCollapse={() => setIsCollapsed(!isCollapsed)}
      />
      <MainContent $isCollapsed={isCollapsed} $fullHeight={isMessagingTab}>
        {children}
      </MainContent>
      {!isMessagingTab && <Footer onNavigateLegal={onNavigateLegal} />}
    </LayoutContainer>
  );
};
